module.exports = __webpack_public_path__ + "img/t3-6.c73f9f7b.png";